
const TermsAndConditions = () => {
  return (
    <>
      <div className="terms-and-condition container">
        <h1>Terms And Conditions</h1>
        <div className="mt-3 mb-5">
          <p>
            Welcome to Bizooka App, (“we,” “our,” “us”). By accessing or using
            our application, you agree to comply with and be bound by these
            Terms & Conditions. If you do not agree, please refrain from using
            the platform.
          </p>
          <br />
          <h3>1. Acceptance of Terms </h3>
          <p>
            By signing up and using Bizooka, you acknowledge that you have read,
            understood, and agree to these Terms. These Terms constitute a
            legally binding agreement between you and Bizooka.
          </p>
          <br />
          <h3>2. User Accounts </h3>
          <ul className="ms-4">
            <li className="list-style-dot">
              To use certain features of the app, you must create an account by
              providing accurate and complete information, including First Name,
              Last Name, Email Address, and Password.
            </li>
            <li className="list-style-dot">
              Users may create personalized profiles, including a name, profile
              picture, bio, preferences, and location settings.{" "}
            </li>
            <li className="list-style-dot">
              Businesses registering on the platform must provide valid business
              details, such as business name, description, location, contact
              details, and required verification documents.
            </li>
            <li className="list-style-dot">
              You are responsible for maintaining the confidentiality of your
              login credentials and agree to notify us immediately of any
              unauthorized use of your account.{" "}
            </li>
            <li className="list-style-dot">
              We reserve the right to suspend or terminate accounts that provide
              false information, engage in fraudulent activity, or violate these
              Terms
            </li>
          </ul>

          <br />
          <h3>3.Content & Conduct </h3>
          <ul className="ms-4">
            <li className="list-style-dot">
              Users and businesses may upload content, including videos, images,
              and descriptions, to showcase their services.
            </li>
            <li className="list-style-dot">
              You retain ownership of any content you post but grant us a
              worldwide, non-exclusive, royalty free license to use, distribute,
              modify, and display such content within the app.
            </li>
            <li className="list-style-dot">
              Businesses registering on the platform must provide valid business
              details, such as business name, description, location, contact
              details, and required verification documents.
            </li>
            <li className="list-style-dot">
              All content must comply with legal and ethical standards. Content
              that is offensive, discriminatory, defamatory, obscene, or in
              violation of any law is strictly prohibited.
            </li>
            <li className="list-style-dot">
              We reserve the right to remove or restrict access to content
              deemed inappropriate without prior notice
            </li>
          </ul>
          <br />
          <h3>4. Business Verification & Responsibilities </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              Businesses must provide accurate details and required verification
              documents to obtain a verified badge.
            </li>
            <li className="list-style-dot">
              Verified businesses are responsible for ensuring that their
              listings, promotions, and interactions comply with applicable
              laws.
            </li>
            <li className="list-style-dot">
              We do not guarantee the accuracy or authenticity of business
              claims, and users should exercise discretion when engaging with
              businesses.
            </li>
          </ul>
          <br />
          <h3>5. Moderation & Suspension </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              We reserve the right to suspend or terminate user or business
              accounts for violations of these Terms, including fraudulent
              activities, inappropriate behavior, or failure to comply with
              verification requirements.
            </li>
            <li className="list-style-dot">
              Content that violates these Terms may be removed at our
              discretion, and repeated violations may lead to permanent account
              suspension
            </li>
          </ul>
          <br />
          <h3>6. Payments & No Refund Policy </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              Certain features or services within the app may require payment.
              Payments made are nonrefundable under any circumstances
            </li>
            <li className="list-style-dot">
              Users agree to pay all applicable fees and charges associated with
              premium services, as outlined in the app.
            </li>
            <li className="list-style-dot">
              We may change our pricing structure at any time, with notice
              provided via the app or email
            </li>
          </ul>
          <br />
          <h3>7. Limitation of Liability</h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              We provide this platform "as is" and "as available" without any
              warranties of any kind, either express or implied.
            </li>
            <li className="list-style-dot">
              We do not assume responsibility for any direct, indirect,
              incidental, or consequential damages arising from the use of our
              services, including but not limited to loss of business, profits,
              or data.
            </li>
            <li className="list-style-dot">
              We are not liable for disputes between users and businesses or any
              third-party interactions facilitated through the app.
            </li>
          </ul>
          <br />
          <h3>8. Changes to Terms</h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              We reserve the right to update or modify these Terms at any time.
              Continued use of the app signifies acceptance of the updated
              terms.
            </li>
            <li className="list-style-dot">
              Users will be notified of significant changes via email or app
              notifications
            </li>
          </ul>
          <br />
          <h3>9. Governing Law & Dispute Resolution </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              These Terms shall be governed by and construed in accordance with
              the laws of the United States.
            </li>
            <li className="list-style-dot">
              Any disputes arising from these Terms shall be resolved through
              binding arbitration in [Jurisdiction], with each party bearing its
              own costs
            </li>
          </ul>
          <br />
        </div>
      </div>
    </>
  );
};
export { TermsAndConditions };

